import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from 'src/i18n'
import { LocalStorage } from 'quasar'

Vue.use(VueI18n)

const getLanguage = () => {
  let chooseLanguage = LocalStorage.getItem('language')
  // TODO
  if (chooseLanguage === 'undefined') chooseLanguage = undefined
  if (chooseLanguage) return chooseLanguage

  // if has not choose language
  const language = (navigator.language || navigator.browserLanguage).toLowerCase()
  const locales = Object.keys(messages)
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale
    }
  }
  return 'en'
}

const i18n = new VueI18n({
  locale: getLanguage(),
  fallbackLocale: 'en',
  messages
})

export default ({ app }) => {
  // Set i18n instance on app
  app.i18n = i18n
}

export { i18n, getLanguage }
